import { SkinColorsEnum } from "../Types/SkinColors";

export const EthnicitySkinColorMap: Record<string, Array<SkinColorsEnum>> = {
    "African": [SkinColorsEnum.Dark, SkinColorsEnum.Darker, SkinColorsEnum.Brown],
    "Arab": [SkinColorsEnum.Brown, SkinColorsEnum.Dark],
    "Asian": [SkinColorsEnum.Paler, SkinColorsEnum.Pale, SkinColorsEnum.Brown],
    "Baltic": [SkinColorsEnum.Default, SkinColorsEnum.Whiter],
    "Black/African-American": [SkinColorsEnum.Dark, SkinColorsEnum.Darker],
    "Caribbean": [SkinColorsEnum.Brown, SkinColorsEnum.Dark, SkinColorsEnum.Darker],
    "Caucasian": [SkinColorsEnum.Default, SkinColorsEnum.Whiter, SkinColorsEnum.Pale],
    "Central American": [SkinColorsEnum.Brown, SkinColorsEnum.Dark],
    "East Asian": [SkinColorsEnum.Pale, SkinColorsEnum.Paler],
    "Eastern European": [SkinColorsEnum.Default, SkinColorsEnum.Whiter],
    "Hispanic/Latino": [SkinColorsEnum.Brown, SkinColorsEnum.Dark],
    "Indian": [SkinColorsEnum.Brown, SkinColorsEnum.Dark],
    "Indigenous Australian": [SkinColorsEnum.Dark, SkinColorsEnum.Darker],
    "Middle Eastern": [SkinColorsEnum.Brown, SkinColorsEnum.Dark],
    "Native American": [SkinColorsEnum.Brown, SkinColorsEnum.Dark],
    "North African": [SkinColorsEnum.Brown, SkinColorsEnum.Dark],
    "Pacific Islander": [SkinColorsEnum.Brown, SkinColorsEnum.Dark],
    "Scandinavian": [SkinColorsEnum.Default, SkinColorsEnum.Whiter],
    "South American": [SkinColorsEnum.Brown, SkinColorsEnum.Dark],
    "South Asian": [SkinColorsEnum.Brown, SkinColorsEnum.Dark],
    "Southeast Asian": [SkinColorsEnum.Brown, SkinColorsEnum.Dark],
    "Sub-Saharan African": [SkinColorsEnum.Dark, SkinColorsEnum.Darker],
    "Western European": [SkinColorsEnum.Default, SkinColorsEnum.Whiter, SkinColorsEnum.Pale],
};